<template>
    <section
        class="content-search-engine-optimization"
        v-html="content"
    />
</template>
<script lang="ts" setup>
    defineProps<{ content: string }>();
</script>
<style lang="postcss">
    .seo_content_2 details summary {
        @apply bg-primary text-white cursor-pointer p-3;
        margin: 1px;
    }
    .seo_content_1, .seo_content_2 {
        @apply text-sm;
        & ul {
            @apply list-disc list-inside;
            padding-left: 30px;
        }
        & input[type=button] {
            @apply btn-primary px-6 py-3 font-bold cursor-pointer;
        }
        & p {
            margin-bottom: 10px;
        }
        & h2 {
            @apply text-2xl;
            padding: 20px 0px 15px;
            line-height: 1.1;
        }
        & h3 {
            font-size: 24px;
            padding: 20px 0px 15px;
            line-height: 1.1;
        }
        & h4 {
            font-size: 24px;
            padding: 10px 0 15px;
            line-height: 1.1;
        }
        & table {
            display: table;
            width: auto;
            height: auto;
            margin: 0;
            padding: 0;
            border: 1px solid;
            border-collapse: inherit;
            border-color: inherit;
            vertical-align: inherit;
            text-align: left;
            font-weight: inherit;
        }
        &::marker {
            font-size: auto;
        }
        & a {
            @apply text-primary;
        }
    }
     .--open {
        @apply text-paragraph-light;
    }
    .featureFilters .--list-child {
        @apply pl-0;
    }
     .-selected-item {
        @apply text-primary font-semibold;
    }
     .selected-filter {
        @apply text-primary;
    }
    & .article-list {
        @apply p-4 lg:pl-4;
        &.design-line {
            & .entry {
                @apply grid grid-cols-1 gap-4 lg:gap-8 lg:grid-cols-12 lg:py-8;
            }
            & .picture {
                @apply lg:col-span-3;
            }
            & .article-info {
                @apply lg:col-span-6;
                & .name {
                    @apply text-lg text-primary;
                }
            }
            & .checkout-info {
                @apply lg:col-span-3;
            }
            & .cta-pds {
                @apply btn-primary px-5 py-3 my-5 inline-block;
            }
        }
        &.design-tile {
            @apply grid grid-cols-1 gap-6 lg:grid-cols-5;
            & .entry {
                @apply flex flex-col gap-4;
            }
            & .cta-pds {
                @apply hidden;
            }
            & .article-info {
                @apply order-3;
                & .name {
                    @apply line-clamp-3 text-xs mb-7;
                }
            }
            & .delivery-info {
                line-height: 1;
            }
        }
    }
    [data-contrast="high"] .seo_content_2 a, [data-contrast="high"] .seo_content_1 a {
        @apply font-bold underline;
    }
</style>
